// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NsX9r","colBig":"styles_colBig__3z_Eu","colSmall":"styles_colSmall__3Ctz1"};